import { render, staticRenderFns } from "./DocumentCommentForm.vue?vue&type=template&id=753c4756&"
import script from "./DocumentCommentForm.vue?vue&type=script&lang=js&"
export * from "./DocumentCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('753c4756')) {
      api.createRecord('753c4756', component.options)
    } else {
      api.reload('753c4756', component.options)
    }
    module.hot.accept("./DocumentCommentForm.vue?vue&type=template&id=753c4756&", function () {
      api.rerender('753c4756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/forms/documents/DocumentCommentForm.vue"
export default component.exports